import { ReactNode } from "react";
import { S } from "./FullLayout.style";

export const FullLayout = ({ children }: { children: ReactNode }) => {
  return <S.Template>{children}</S.Template>;
};
